import { Popover } from './types';

const popoverTheme: Popover = {
	colors: {
		background: '',
		border: '',
		modes: {
			light: {
				background: 'neutral.0',
				border: 'neutral.0'
			},
			dark: {
				background: 'neutral.800',
				border: 'neutral.700'
			}
		}
	}
};

export default popoverTheme;
